import { isStringNullOrWhiteSpace } from 'owa-localize';
import FindPeopleControl from './FindPeopleControl';
import updateQueryString from '../actions/updateQueryString';
import populateFindControlInitialState, { FindControlStore } from '../store/store';
import { getReadWriteRecipientViewStateFromFindRecipientPersonaType } from 'owa-recipient-create-viewstate/lib/util/getReadWriteRecipientViewStateFromFindRecipientPersonaType';
import { observer } from 'mobx-react';
import setForceResolveState from 'owa-readwrite-recipient-well/lib/actions/setForceResolveState';
import updateIsEditing from 'owa-readwrite-recipient-well/lib/actions/updateIsEditing';
import FindControlViewState from 'owa-recipient-types/lib/types/FindControlViewState';
import FindRecipientPersonaType from 'owa-recipient-types/lib/types/FindRecipientPersonaType';
import ReadWriteRecipientViewState from 'owa-recipient-types/lib/types/ReadWriteRecipientViewState';

import * as React from 'react';

let styles = require('./EditingReadWriteRecipient.scss');
export interface ReadWriteRecipientProps {
    recipient: ReadWriteRecipientViewState;
    onEditingFinished: (
        editedItem: ReadWriteRecipientViewState,
        newItem: ReadWriteRecipientViewState
    ) => void;
    removeOperation: (recipientToRemove: ReadWriteRecipientViewState) => void;
    inForceResolve: boolean;
    editingRecipientInputClassName?: string;
}
export interface ReadWriteRecipientState {
    findControlViewState: FindControlViewState;
}
@observer
export default class EditingReadWriteRecipient extends React.Component<
    ReadWriteRecipientProps,
    ReadWriteRecipientState
> {
    private findControl: FindPeopleControl;
    private store: FindControlStore;

    constructor(props: ReadWriteRecipientProps) {
        super(props);
        this.store = populateFindControlInitialState();
        updateQueryString(this.store.viewState, props.recipient.displayText);
        setForceResolveState(this.store.viewState, props.inForceResolve);
    }

    render() {
        return (
            <FindPeopleControl
                ref={(ref: FindPeopleControl) => (this.findControl = ref)}
                viewState={this.store.viewState}
                onItemSelected={this.onItemSelected}
                focusAutomatically={true}
                openPickerAutomatically={true}
                onBlur={this.onBlur}
                onInputChanged={this.onInputChanged}
                className={styles.findPeopleControl}
                editingRecipientInputClassName={this.props.editingRecipientInputClassName}
            />
        );
    }
    private onItemSelected = (item: FindRecipientPersonaType) => {
        let newRecipient: ReadWriteRecipientViewState = getReadWriteRecipientViewStateFromFindRecipientPersonaType(
            item
        );

        this.props.onEditingFinished(this.props.recipient, newRecipient);
    };

    private onInputChanged = (inputValue: string) => {
        if (isStringNullOrWhiteSpace(inputValue)) {
            this.props.removeOperation(this.props.recipient);
        }
    };
    private onBlur = () => {
        if (
            !isStringNullOrWhiteSpace(this.store.viewState.queryString) &&
            this.props.recipient.displayText !== this.store.viewState.queryString
        ) {
            this.findControl.getFloatingPicker().forceResolveSuggestion();
        } else {
            updateIsEditing(this.props.recipient, false /*isEditing*/);
        }
    };
}
